import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { ModalWindowModule } from '../../../modal-window/modal-window.module';
import { UpdateAgencyLeadModalComponent } from './update-agency-lead-modal.component';
import { UpdateAgencyLeadModalService } from './update-agency-lead-modal.service';
import { DxDropDownBoxModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';

@NgModule({
  imports: [SharedModule, ModalWindowModule, DxDropDownBoxModule, DxValidatorModule, DxValidationSummaryModule],
  declarations: [UpdateAgencyLeadModalComponent],
  exports: [UpdateAgencyLeadModalComponent],
  providers: [UpdateAgencyLeadModalService],
})
export class UpdateAgencyLeadModalModule {}
